import { WebCompatibleWebView } from '@/src/common/components/WebCompatibleWebView'
import { Loading } from '@/src/common/components/Loading'
import { useLogError } from '@/src/common/hooks/useLogError'
import { useState } from 'react'
import { Text, View } from 'react-native'
import { maxWidth } from '@/src/common/wrappers/MainWrapper'
import * as Ids from '@/src/experiences/card-statements/e2e/ids'
import { NoTransactions } from '@/src/experiences/card-activity/icons/no-transactions'
import { mesaColorNames, typography } from '@/src/common/theme'
import { useAlert } from '@/src/components/ui/elements/dialogs/useAlert'
import { routerBack } from '@/src/common/utils/routerBack'
import { withStatementScreen } from '@/src/experiences/card-statements/Statement/withStatementScreen'

export default withStatementScreen(function Statement({ statementScreenProps }) {
  const logError = useLogError()
  const [loaded, setLoaded] = useState(false)
  const Alert = useAlert(Statement.name)
  const { Modal, options, pdfLink, error } = statementScreenProps

  return Modal({
    contentContainerProps: { style: { width: maxWidth, height: '88%' } },
    children: (
      <>
        {options.header()}
        {statementScreenProps.loading ? (
          <Loading />
        ) : error || !pdfLink ? (
          <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <NoTransactions
              svgProps={{ style: { marginHorizontal: 'auto' } }}
              pathProps={{ fill: mesaColorNames['Mesa - Brand/White #FFFFFF'] }}
            />
            <Text
              style={[
                typography.L,
                {
                  textAlign: 'center',
                  color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
                  marginTop: 32,
                  marginBottom: 32,
                },
              ]}
            >
              Statement unavailable
            </Text>
          </View>
        ) : (
          <WebCompatibleWebView
            onError={(evt) => {
              logError(new Error('Failed to render statement PDF', { cause: evt.nativeEvent }))
              Alert.alert(
                'Error',
                'We had an issue fetching your statement. Please try again later.',
              )
              void routerBack()
            }}
            source={pdfLink}
            containerStyle={{ flex: 1 }}
            onLoad={() => setLoaded(true)}
            testID={loaded ? Ids.StatementLoaded : undefined}
          />
        )}
      </>
    ),
  })
})
